<icz-section label="Informace o spisu">
  <icz-entity-info [entity]="file"></icz-entity-info>
</icz-section>
<form [formGroup]="form" [waiting]="loadingService.isLoading$(this) | async">
  <div class="col grow">
    <div class="row grow">
      <icz-section label="Zatřídění" class="grow">
        @if (availableFileTypes) {
          <icz-form-autocomplete
            [options]="fileTypeOptions"
            formControlName="fileTypeId"
            label="Typ spisu"
          ></icz-form-autocomplete>
        }
        @else {
          <icz-file-type-selector
            [date]="settlementDate"
            [form]="form"
            [mode]="VisibleClassifiersMode.VALID_AT_GIVEN_DATE"
            controlName="fileTypeId"
          ></icz-file-type-selector>
        }

        <icz-entity-class-selector
          [form]="form"
          controlName="entityClassId"
          [showEntityClassesValidAt]="closeDate"
          [usage]="EntityClassSelectorUsage.OFFICER_CURRENT_WITHOUT_V"
          [selectorEntityClassType]="file?.caseFile ? null : EntityClassType.DOCUMENT_FILE"
          [fieldDisabled]="!!file?.caseFile"
        ></icz-entity-class-selector>

      </icz-section>
      <icz-section label="Datum uzavření" class="grow">
        <div class="row">
          <icz-date-picker class="grow" label="Datum uzavření" formControlName="closeDate" outputFormat="dateTime"></icz-date-picker>
        </div>
      </icz-section>
    </div>
    <icz-section label="Skartační režim">
      <div class="row-24 grow">
        <div class="col grow">
          <icz-form-field formControlName="disposalOperationCode" label="Výsledný skartační znak"></icz-form-field>
          <icz-form-autocomplete
            [clearable]="false"
            [options]="retentionTriggerTypesOptions"
            class="grow"
            formControlName="retentionTriggerTypeCode"
            label="Spouštěcí událost"
          ></icz-form-autocomplete>
          @if (isExternalRetentionTriggerTypeWithPeriod()) {
            <icz-ext-retention-trigger-selector
              [form]="form"
              [availableExternalRetentionTriggerIds]="form.get('externalRetentionTriggerIds')!.value ?? []"
            ></icz-ext-retention-trigger-selector>
          }
        </div>
        <div class="col grow">
          <div class="row">
            <icz-form-field class="grow" formControlName="disposalYear" label="Předpokládaný rok vyřazení"></icz-form-field>
            <div class="grow"></div>
          </div>

          <div class="row">
            <icz-form-field class="grow" label="Rok spouštěcí události"  formControlName="yearOfRetentionPeriodStart" type="integer"></icz-form-field>
            @if (isRetentionTriggerTypeWithPeriod()) {
              <icz-form-field class="grow" label="Rok kontroly spouštěcí události"  formControlName="triggerEventCheckYear" type="integer"></icz-form-field>
            }  @else {
              <div class="grow"></div>
            }
          </div>
        </div>
      </div>
    </icz-section>
  </div>
</form>
